/** biome-ignore-all lint/style/noNestedTernary: no nested ternary */
import cx from 'classnames';
import {Typography} from '~library/atoms/Typography';
import {CheckmarkCircleIcon} from '~library/svg/CheckmarkCircleIcon';
import {CloseCircleIcon} from '~library/svg/CloseCircleIcon';
import {QuestionCircleIcon} from '~library/svg/QuestionCircleIcon';
import {feedbackMaybe, feedbackNo, feedbackSuccess} from '~libSass/base/_exports.sass';

const responseMap: Record<'yes' | 'maybe' | 'no', string> = {
  yes: "Yes, you're going",
  maybe: "You RSVP'd Maybe",
  no: "You RSVP'd No",
};

interface RSVPDetailsProps {
  rsvpResponse: 'yes' | 'maybe' | 'no';
  setUpdatingRsvp: (value: true) => void;
  deadlineHasPassed: boolean;
  strictRSVPDeadline?: boolean;
}

export const RSVPDetails = ({
  rsvpResponse,
  setUpdatingRsvp,
  deadlineHasPassed,
  strictRSVPDeadline,
}: RSVPDetailsProps) => {
  return (
    <div
      className={cx('view-invitation__rsvp-details', {
        'view-invitation__rsvp-details--deadline-passed': deadlineHasPassed && strictRSVPDeadline,
      })}
    >
      <div className="view-invitation__rsvp-status-wrapper" data-qa-value={rsvpResponse}>
        {rsvpResponse === 'yes' ? (
          <CheckmarkCircleIcon ratio={0.75} color={feedbackSuccess} />
        ) : rsvpResponse === 'no' ? (
          <CloseCircleIcon ratio={0.75} color={feedbackNo} />
        ) : (
          rsvpResponse === 'maybe' && <QuestionCircleIcon ratio={0.75} color={feedbackMaybe} />
        )}
        <Typography variant="paragraph2" className="view-invitation__rsvp-status" semibold>
          {responseMap[rsvpResponse]}
        </Typography>
      </div>
      {!deadlineHasPassed || !strictRSVPDeadline ? (
        <button
          className="unstyled-button link"
          data-qa-id="invitation-change-rsvp"
          onClick={() => setUpdatingRsvp(true)}
          type="button"
        >
          Change RSVP
        </button>
      ) : (
        <Typography variant="paragraph3" color="asphalt">
          FYI: your host’s RSVP deadline has passed. Contact them directly with any RSVP changes.
        </Typography>
      )}
    </div>
  );
};
